module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3a2d63269c47aa8244b0d613cf50eb6c.svg";